export const getFileFromInputEvent = (e: React.ChangeEvent<HTMLInputElement>) =>
  e.target.files && e.target.files.length ? e.target.files[0] : null

export const validateInputPdfFile = (
  e: React.ChangeEvent<HTMLInputElement>
) => {
  const file = getFileFromInputEvent(e)
  const fileExtentionMatch = file && file.name.match(/\.([^.]+)$/)
  const fileExtention = fileExtentionMatch && fileExtentionMatch[0]
  const isValid =
    file &&
    (fileExtention === '.pdf' ||
      fileExtention === '.jpg' ||
      fileExtention === '.jpeg' ||
      fileExtention === '.png' ||
      file.type === 'application/pdf')

  return { file, isValid }
}

export const validateFileSize = (
  fileSize: number,
  limitInMb?: number
): { isValid: boolean; error?: string } => {
  const fileSizeInMB = fileSize / 1000000
  if (limitInMb && fileSizeInMB > limitInMb) {
    const error = `Dimensioni eccessive: stai provando a caricare un file di ${Math.ceil(
      fileSizeInMB
    )}MB, ma il limite è ${limitInMb}MB`

    return { isValid: false, error }
  }

  return { isValid: true }
}

export const isImageFile = (fileName?: string) => {
  if (!fileName) return false
  const fileExtentionMatch = fileName.match(/\.([^.]+)$/)
  const fileExtention = fileExtentionMatch && fileExtentionMatch[0]
  return (
    fileExtention === '.jpg' ||
    fileExtention === '.jpeg' ||
    fileExtention === '.png'
  )
}

export const downloadBlobFile = (file: Blob, fileName: string) => {
  // for IE we need to use msSaveOrOpenBlob and we are done
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(file)
    return
  }
  // for all other browser we need to create a fake link
  const objectURL = window.URL.createObjectURL(file)
  const link = document.createElement('a')
  link.href = objectURL
  link.download = fileName
  link.click()
  setTimeout(function() {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(objectURL)
  }, 100)
}
